import React from 'react';
import styled from '@emotion/styled';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import mapMarker from '../assets/svgs/map-marker.svg';
import L from 'leaflet';

const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  width: 80%;
  height: 80%;
  position: relative;
  border-radius: 15px;
  overflow: hidden;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 15px;
  z-index: 1000;
  background: none;
  color: black;
  border: none;
  font-size: 25px;
  cursor: pointer;
`;

const MapModal = ({ position, onClose }) => {

    const customIcon = L.icon({
      iconUrl: mapMarker,
      iconSize: [38, 38],
      iconAnchor: [19, 38], 
      popupAnchor: [0, -38],
    });

  return (
    <ModalBackground>
      <ModalContent>
        <CloseButton onClick={onClose}>X</CloseButton>
        <MapContainer center={position} zoom={16} style={{ height: '100%', width: '100%' }}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="&copy; OpenStreetMap contributors"
          />
          <Marker position={position} icon={customIcon}>
            <Popup>Amenity Location</Popup>
          </Marker>
        </MapContainer>
      </ModalContent>
    </ModalBackground>
  );
};

export default MapModal;
